import { defineStore } from 'pinia';

import { AddressDto } from '@tallo/property';

import { InvestorDto } from '../dtos/investor.dto';
import investorService from '../services/investor.service';

export const useInvestorStore = defineStore('globalStore', {
  state: (): {
    investor: InvestorDto | undefined;
  } => ({
    investor: undefined,
  }),
  getters: {
    address(): AddressDto {
      return {
        address: this.investor?.address || '',
        city: this.investor?.city || '',
        state: this.investor?.state || '',
        zip: this.investor?.zip || 0,
        latitude: this.investor?.latitude || 0,
        longitude: this.investor?.longitude || 0,
      };
    },
  },
  actions: {
    async load(): Promise<void> {
      this.investor = await investorService.getInvestor();
    },

    async updateAddress(address: AddressDto): Promise<void> {
      this.investor = await investorService.updateAddress(address);
    },
  },
});
